import {
  Box,
  Card,
  CardContent,
  Divider,
  Skeleton,
  Typography,
} from "@mui/material";
import React, { FC } from "react";

interface SectionCardProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  isLoading?: boolean;
}

const ContentSkeleton: FC = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
    <Skeleton variant="text" width="100%" height={28} />
    <Skeleton variant="text" width="85%" height={28} />
    <Skeleton variant="text" width="70%" height={28} />
    <Skeleton variant="text" width="90%" height={28} />
  </Box>
);

const SectionCard: FC<SectionCardProps> = ({
  title,
  icon,
  children,
  isLoading,
}) => (
  <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
    <Box
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
        backgroundColor: "primary.main",
        color: "primary.contrastText",
      }}
    >
      {icon}
      <Typography variant="h6" component="h2">
        {title}
      </Typography>
    </Box>
    <Divider />
    <CardContent sx={{ flexGrow: 1 }}>
      {isLoading ? <ContentSkeleton /> : children}
    </CardContent>
  </Card>
);

export default SectionCard;
